export { default as CourseVideo } from './CourseVideo';
